import { render, staticRenderFns } from "./DateCross.vue?vue&type=template&id=122ae8b1&scoped=true"
import script from "./DateCross.vue?vue&type=script&lang=js"
export * from "./DateCross.vue?vue&type=script&lang=js"
import style0 from "./DateCross.vue?vue&type=style&index=0&id=122ae8b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122ae8b1",
  null
  
)

export default component.exports